/**
 *
 * layout_headerSticky.js
 *
 *
 */
(() => {


	/**************************************************************
	 * headerSticky
	**************************************************************/
	class headerSticky {
		constructor(options) {
			this.options = options || {};
			this.headerSelector = this.options.headerSelector || '.l-header';
			this.introSelector  = this.options.introSelector  || '.home-intro';
			this.type1Class     = this.options.type1Class     || '-type1';
			this.stickyClass    = this.options.stickyClass    || 'is-sticky';
			this.type1ScrollY   = typeof this.options.type1ScrollY === 'number' ? this.options.type1ScrollY : 200;

			this.header   = null;
			this.intro    = null;
			this.mode     = '';
			this.triggerY = 0;

			this.ticking = false;
			this.onScrollBound = this.onScroll.bind(this);
			this.onResizeBound = this.onResize.bind(this);
			this.onLoadBound   = this.onLoad.bind(this);
		}

		init() {
			this.header = document.querySelector(this.headerSelector);
			if (!this.header) return;

			if (this.header.classList.contains(this.type1Class)) {
				this.mode = 'type1';
			} else {
				this.mode = 'intro';
				this.intro = document.querySelector(this.introSelector);
				this.recalcTrigger();
			}

			window.addEventListener('scroll', this.onScrollBound, { passive: true });
			window.addEventListener('resize', this.onResizeBound);
			window.addEventListener('load', this.onLoadBound);

			this.update();
		}

		onScroll() {
			if (this.ticking) return;

			this.ticking = true;
			window.requestAnimationFrame(this.rafUpdate.bind(this));
		}

		onResize() {
			if (this.mode !== 'intro') return;

			this.recalcTrigger();
			this.onScroll();
		}

		onLoad() {
			if (this.mode !== 'intro') return;

			this.recalcTrigger();
			this.update();
		}

		rafUpdate() {
			this.update();
			this.ticking = false;
		}

		recalcTrigger() {
			if (!this.intro) {
				this.triggerY = this.type1ScrollY;
				return;
			}

			var rect = this.intro.getBoundingClientRect();
			this.triggerY = rect.top + window.pageYOffset;
		}

		update() {
			var y = window.pageYOffset;
			var shouldSticky = false;

			if (this.mode === 'type1') {
				shouldSticky = y > this.type1ScrollY;
			} else {
				shouldSticky = y >= this.triggerY;
			}

			if (shouldSticky) {
				this.header.classList.add(this.stickyClass);
			} else {
				this.header.classList.remove(this.stickyClass);
			}
		}
	}

	const sticky = new headerSticky({
		headerSelector: '.l-header',
		introSelector : '.home-intro__main',
		type1Class    : '-type1',
		stickyClass   : 'is-sticky',
		type1ScrollY  : 200
	});
	sticky.init();








})();
